/**
 * Displays the product grid containing product cards if fetched products are currently available.
 */
import React, { useContext } from "react";
import styled from "styled-components";
import ProductCard from "./ProductCard";
import ResultsToolbar from "./ResultsToolbar";
import ResultsHeading from "./ResultsHeading";
import { PeriodicTableContext } from "./PeriodicTableContext";

const ProductGrid = () => {
  const { productsSorted, productsLoading, isSearchPerformed } = useContext(
    PeriodicTableContext
  );

  if (productsLoading) {
    return (
      <>
        <ResultsHeading />
				<div style={{ textAlign: "center" }}>Products loading...</div>
      </>
    );
  }

  if (productsSorted.length) {
    return (
      <>
        <ResultsHeading />
        <ResultsToolbar />
        <div className="products-section-grid product-listing">
          {productsSorted.map((product, index) => {
            return <ProductCard key={index} product={product} />;
          })}
        </div>
      </>
    );
  }

  if (isSearchPerformed && !productsSorted.length) {
    return (
      <NoResults>No results were found. Please try searching again.</NoResults>
    );
  }

  return <></>;
};

export default ProductGrid;

const NoResults = styled.div`
  text-align: center;
  font-weight: bold;
`;
